import type { UtilityContext } from '@change/core/react/utilityContext';

import { normalizeReportApiPayload } from './shared/normalize';
import type { Report, ReportApiPayload } from './shared/types';

export async function reportAbuse(report: Report, { http: { post } }: UtilityContext): Promise<void> {
	await post<ReportApiPayload>('/api-proxy/-/abuse_reports', normalizeReportApiPayload(report));
}
